<template>
  <div id="app">
    <router-view />

    <base-notification
      :duration="20000"
      group="system"
      position="bottom left"
    />

    <base-notification
      :duration="5000"
      group="validation"
      position="bottom right"
    />

    <!-- <base-modal
      v-if="isProductionEnvironment && productionEnvironmentModalIsOpen"
      size="small"
    >
      <template #content>
        <base-card-section>
          <base-text-container>
            <base-stack>
              <base-stack-item>
                <base-text-style variation="negative">
                  <base-icon icon="warning" />
                </base-text-style>
              </base-stack-item>

              <base-stack-item>
                <base-heading>Caution: production environment</base-heading>
              </base-stack-item>
            </base-stack>

            <p>By accessing this domain you are accessing our production environment, which means that any changes to renewals, payments and settings will take immediate effect.</p>
          </base-text-container>
        </base-card-section>

        <base-card-section>
          <base-stack distribution="trailing">
            <base-stack-item>
              <base-button
                type="warning"
                @click="productionEnvironmentModalIsOpen = false"
              >
                Let me use this domain
              </base-button>
            </base-stack-item>

            <base-stack-item>
              <base-button
                type="primary"
                @click="goToTestingEnvironment"
              >
                Go to testing domain
              </base-button>
            </base-stack-item>
          </base-stack>
        </base-card-section>
      </template>
    </base-modal> -->
  </div>
</template>

<script>
export default {
  data() {
    return {
      isClientOnline: navigator.onLine,
      productionEnvironmentModalIsOpen: true,
    };
  },
  computed: {
    isProductionEnvironment() {
      return process.env.NODE_ENV === "production";
    },
  },
  watch: {
    isClientOnline(value) {
      if (value) {
        this.notifyConnectionOnline();
      } else {
        this.notifyConnectionOffLine();
      }
    },
  },
  mounted() {
    window.addEventListener("online", this.updateConnection);
    window.addEventListener("offline", this.updateConnection);
  },
  beforeDestroy() {
    window.removeEventListener("online", this.updateConnection);
    window.removeEventListener("offline", this.updateConnection);
  },
  methods: {
    goToTestingEnvironment() {
      location.replace(
        `https://develop--validation-platform.netlify.com${this.$route.fullPath}`
      );
    },
    updateConnection(e) {
      const { type } = e;

      this.isClientOnline = type === "online";
    },
    notifyConnectionOnline() {
      this.$notify({
        group: "system",
        title: "Internet connection established",
        text: "You may have unsaved changes. Please refresh your browser to get the latest updates to your platform.",
        data: {
          type: "success",
          icon: "wifi",
          actions: [
            {
              name: "Close",
              onClick: (closeNotification) => closeNotification(),
            },
          ],
        },
      });
    },
    notifyConnectionOffLine() {
      this.$notify({
        group: "system",
        title: "No internet connection",
        text: "You are not connected to the internet. Please connect to your wifi to continue using the platform.",
        data: {
          type: "error",
          icon: "wifi_off",
          actions: [
            {
              name: "Close",
              onClick: (closeNotification) => closeNotification(),
            },
          ],
        },
      });
    },
  },
};
</script>
